export enum MapPageSplitScreenTab {
  Spreadsheet = 'split-tab-spreadsheet',
  Chart = 'split-tab-chart',
}
